<template>
<div>
    
    <div class="container mt-4">
        <div class="d-flex justify-content-between header p-3 pl-5 pr-5">
            <img :src="logotipo">
            <!--<img src="../assets/img/logo_denuncia.png">-->

            <div class="align-self-center">
                <div class="text-center den-title">
                    <h1>{{view_nome.titulo_denuncia}}</h1>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="container">
                <transition mode="out-in" name="leftIn">
                    <router-view></router-view>
                </transition>
            </div>
        </div>

        <div class="d-flex justify-content-center footer">
            <div class="d-flex align-items-center">
                Todos os direitos reservados © 2019.&nbsp;<a href="https://www.dad.eng.br" target="_blanck">DAD Tecnologia</a>
            </div>
        </div>

        <br>
    </div>
</div>
</template>

<script>
    export default {
        name: "Denuncia-online",
        computed: {
            logotipo() { return this.$store.state.config.logotipo },
            view_nome(){ return this.$store.state.config_view_menu }
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Bebas+Neue&display=swap');

    body {
        background: linear-gradient(135deg, rgb(204, 204, 204), rgb(179, 178, 178));
    }

    .content {
        background: linear-gradient(135deg, rgb(218, 218, 218), rgb(255, 255, 255));
        margin: 0;
        padding: 20px;
    }

    .header, .footer {
        background: linear-gradient(135deg, rgb(148, 148, 148), rgb(155, 155, 155));
    }

    .footer {
        height: 40px;
        font-size: 12px;
        color: white;
    }

    .footer a {
        color: azure;
        font-weight: bold;
    }

    .footer a:hover {
        color: rgb(60, 128, 103)
    }

    .header img {
        height: 220px;
    }

    .den-title {
        font-family: 'Bebas Neue', cursive;
    }
</style>